import { useEffect, useState } from "react";
import { fetchMyMakeupClass } from "../../context/actions/attendance";

function formatWhen(isoString) {
  if (!isoString) return "";
  const date = new Date(isoString);
  const datePart = date.toLocaleDateString([], { weekday: "short", month: "short", day: "numeric" });
  const timePart = date.toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" });
  return `${datePart} · ${timePart}`;
}

export default function MakeupClassBanner() {
  const [makeupClass, setMakeupClass] = useState(null);
  const [dismissed, setDismissed] = useState(() => {
    try {
      return JSON.parse(sessionStorage.getItem("dismissed_makeup_classes") || "[]");
    } catch {
      return [];
    }
  });

  useEffect(() => {
    fetchMyMakeupClass().then(setMakeupClass);
  }, []);

  if (!makeupClass || dismissed.includes(makeupClass.id)) return null;

  const isLive = makeupClass.status === "live";

  const handleDismiss = () => {
    const next = [...dismissed, makeupClass.id];
    setDismissed(next);
    sessionStorage.setItem("dismissed_makeup_classes", JSON.stringify(next));
  };

  return (
    <div className="innersection pt-4">
      <div className="flex items-start gap-3 px-4 py-3 rounded-xl border bg-violet-50 border-violet-200 mb-3">
        <span className="text-xl flex-shrink-0 mt-0.5">🔁</span>

        <div className="flex-1 min-w-0">
          <div className="flex items-center gap-2 flex-wrap mb-0.5">
            <span className="text-xs font-semibold px-2 py-0.5 rounded-full bg-violet-100 text-violet-700">
              {isLive ? "Makeup Class · Live Now" : "Upcoming Makeup Class"}
            </span>
            <span className="text-xs text-violet-500">{formatWhen(makeupClass.start_time)}</span>
          </div>
          <p className="text-sm text-gray-700">
            {makeupClass.topic || "Makeup Session"}
            {makeupClass.course_name ? ` — ${makeupClass.course_name}` : ""}
          </p>
        </div>

        <div className="flex items-center gap-2 flex-shrink-0">
          {makeupClass.link && (
            <a
              href={makeupClass.link}
              target="_blank"
              rel="noopener noreferrer"
              className="text-xs font-medium px-3 py-1.5 rounded-lg transition-colors bg-violet-600 hover:bg-violet-700 text-white"
            >
              Join Class
            </a>
          )}
          <button
            onClick={handleDismiss}
            className="text-gray-400 hover:text-gray-600 text-lg leading-none"
            aria-label="Dismiss"
          >
            ×
          </button>
        </div>
      </div>
    </div>
  );
}
